import template from './leave_adjustments_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class LeaveAdjustmentsHelpPageViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveAdjustmentsHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveAdjustmentsHelpPageViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveAdjustmentsHelp',
	dialog_class: LeaveAdjustmentsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_adjustments_help',
	provider: 'ps'
};
